module.exports = __webpack_public_path__ + "static/media/host_review.2df0810f.svg";